import { render, staticRenderFns } from "./ConfirmMessage.vue?vue&type=template&id=a51c614a"
import script from "./ConfirmMessage.vue?vue&type=script&lang=js"
export * from "./ConfirmMessage.vue?vue&type=script&lang=js"
import style0 from "./ConfirmMessage.vue?vue&type=style&index=0&id=a51c614a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports